const ICONS = {
  APPOINTMENT_REQUEST: '📅',
  APPOINTMENT_APPROVED: '✅',
  APPOINTMENT_ASSIGNED: '👤',
  APPOINTMENT_ASSIGNMENT_REJECTED: '↩️',
  APPOINTMENT_COMPLETED: '✨',
  ORDER_PLACED: '🛒',
  ORDER_CONFIRMED: '✅',
  ORDER_SHIPPED: '📦',
  ORDER_DELIVERED: '🎉',
  PAYMENT_SLIP_UPLOADED: '💳',
  REVIEW_RECEIVED: '⭐',
  REVIEW_UPDATED: '✏️',
};

export const notificationIcon = (type) => ICONS[type] || '🔔';
